import { getAgentId } from 'utils/getValue';

const bankcomm = {
  // A10036 新加坡樟宜机场
  N00805: 10,
  N01131: 9,
  N00165: 8,
  N01642: 7,
  // A10030 曼谷素万那普机场
  N04349: 10,
  N03756: 9,
  N03315: 8,
  N03115: 7,
  N04269: 6,
  N01342: 5,
  N00115: 4,
  N00109: 3,
  // A10023 吉隆坡国际机场
  N03675: 10,
  N04687: 9,
  N04540: 8,
  N01356: 7,
  // A10552 曼谷廊曼国际机场
  N01783: 10,
  N02267: 9,
  N01180: 8,
  N01178: 7,
};

const getSortLoungeData = () => {
  const agentId = getAgentId();

  const bankcommAgentId = [
    '9048',
    '9259',
    '5278',
    '5279',
    '5280',
    '5295',
    '6382',
    '6401',
    '17491',
    '19397',
    '19396',
    '24440',
    '35641',
  ];
  if (bankcommAgentId.includes(agentId)) return bankcomm;
  return false;
};

export default getSortLoungeData;
